import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-3701" data-mp="129z1odrtp7i6">
      <Navbar data-id="element-3702" data-mp="xamefrx1hyf2" />
      <main data-id="element-3703" data-mp="xa4b6bbymjxn">
        <ConsularAffairs data-id="element-3704" data-mp="xae344gkf15z" />
      </main>
      <Footer data-id="element-3705" data-mp="xbfbu2a3zbkj" />
    </div>;
}